<template>
  <h1 class="title">
    <a :href="indexUrl" class="title__anchor">
      <span class="title__logo"/>
      <span class="title__text">お店管理画面</span>
    </a>
  </h1>
</template>
<script>
import { VTRestaurantId } from '@/mikan/_shared/types/vueTypes/restaurant';
import { buildRestaurantIndexUrl } from '@/mikan/_shared/lib/urlBuilders';

export default {
  props: {
    restaurantId: VTRestaurantId,
  },
  computed: {
    indexUrl() {
      return this.restaurantId ? buildRestaurantIndexUrl(this.restaurantId) : '';
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@/mikan/pc/base/constants';
@import '~@/mikan/_shared/fonts/iconfont';

.title {
  display: flex;
  color: white;

  &__anchor {
    display: flex;
    align-items: center;
    color: inherit;
  }

  &__logo {
    @include iconfont(logo);

    font-size: 26px;
    line-height: 1;
  }

  &__text {
    margin-bottom: 5px;
    font-size: $size-ll;
    font-weight: bold;

    &:nth-child(n + 2) {
      margin-left: 8px;
    }
  }
}
</style>
